import styled from 'styled-components';
import { Select } from '@material-ui/core';

export const KicksTable = styled.div`
  height: 800px;
  width: 100%;
  padding: 5px;
  display: flex;
`;

export const KicksSelect = styled(Select)`
  min-width: 180px;
`;

export const KicksComboBox = styled.div`
  padding: 10px;
  display: inline;
`;
